{
    "Profile_Dwellings_ScheduledItem.scheduledItem": "FR: Scheduled Item",
    "Profile_Dwellings_ScheduledItem.scheduledItemDetails": "FR: Scheduled Item Details",
    "Profile_Dwellings_ScheduledItem.type": "FR: Type",
    "Profile_Dwellings_ScheduledItem.insuredValue": "FR: Insured Value"
}
